import { render, staticRenderFns } from "./ExistingReturnLabels.vue?vue&type=template&id=6b2e0c70&"
import script from "./ExistingReturnLabels.vue?vue&type=script&lang=js&"
export * from "./ExistingReturnLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports